import { Tooltip } from '@/components/basicComponents/tooltip';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

interface EllipsisWithTooltipProps {
  children: React.ReactNode;
  title: React.ReactNode;
  maxContentWidth?: number;
  className?: string;
  lines?: number;
  forceRecalculate?: boolean; // Optional prop to force recalculation
}

export const EllipsisWithTooltip = ({ children, title, className, lines = 1, forceRecalculate, maxContentWidth }: EllipsisWithTooltipProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const el = ref.current;
      if (el) {
        setIsOverflowed(el.scrollHeight > el.clientHeight);
      }
    }, 1000);
  }, [children, lines, forceRecalculate]);

  const Content = (
    <EllipsisDiv ref={ref} className={className} lines={lines}>
      {children}
    </EllipsisDiv>
  );

  return isOverflowed ? (
    <Tooltip title={title} maxContentWidth={maxContentWidth} placement="top" arrow>
      {Content}
    </Tooltip>
  ) : (
    Content
  );
};

const EllipsisDiv = styled.div<{ lines: number }>`
  text-overflow: ellipsis;
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
`;
